import React from "react";
import i18n from "../../i18n";
import { Trans } from "react-i18next";

import { Button, FormGroup, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";

export class GranularitySelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      equipments: [],
      selection: props.selection !== undefined ? props.selection : 0,
      label: props.displayLabel !== false ? <Trans>select a granularity</Trans> : "",
    };
    this.granularity = [
      { value: 0, label: i18n.t("automatic") },
      { value: 1, label: `10 ${i18n.t("minutes")}` },
      { value: 2, label: `15 ${i18n.t("minutes")}` },
      { value: 3, label: `30 ${i18n.t("minutes")}` },
      { value: 4, label: `1 ${i18n.t("hour")}` },
      { value: 5, label: `4 ${i18n.t("hours")}` },
      { value: 6, label: `1 ${i18n.t("day")}` },
    ];
  }

  getLabelSelection(id) {
    const val = this.granularity.find((g) => {
      return g.value === id;
    })?.label;
    return val;
  }

  render() {
    return (
      <FormGroup label={this.state.label} labelFor="input_name" inline={true}>
        <Select
          items={this.granularity}
          itemRenderer={(item, { select, modifiers }) => {
            return (
              <MenuItem
                key={"ID_Granulatiry:" + item.value}
                label={item.label}
                text={item.label}
                onClick={(it) => {
                  this.props.onSelect(item.value);
                  this.setState({
                    open: false,
                    selection: item.value,
                  });
                }}
              />
            );
          }}
        >
          <Button
            text={this.getLabelSelection(this.state.selection)}
            rightIcon="double-caret-vertical"
          />
        </Select>
      </FormGroup>
    );
  }
}
